import React, { useEffect } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getRestaurantById } from "../../../actions/restaurants";
import { slugify } from "../../../util/slugify";

const RestaurantDetailsRedirect = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const restaurants = useSelector((state) => state.restaurant.restaurants);
  const restaurant = restaurants.find((r) => r._id === id);

  useEffect(function fetchRestaurantForRedirect() {
    if (!restaurant) {
      dispatch(getRestaurantById(id));
    }
  }, [id, restaurant, dispatch]);

  if (!restaurant) return null; // Loading — server redirect handles crawlers

  const slug = slugify(restaurant.name);
  const qs = searchParams.toString();
  const to = `/details/${id}/${slug}${qs ? `?${qs}` : ""}`;

  return <Navigate to={to} replace />;
};

export default RestaurantDetailsRedirect;
